import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { observer } from "mobx-react";

import { Header } from "../../components/Header";
import "./BusinessRegistration.scss";
import { Link, useHistory } from "react-router-dom";
import { DATA_PRIVACY, PERSON_REGISTRATION } from "../../constants/routes";
import {
  CONTINUE_BUTTON,
  REGISTRATION_ACCEPT,
  REGISTRATION_ADDRESS,
  REGISTRATION_COMPANY_NAME,
  REGISTRATION_COMPANY_TITLE,
  REGISTRATION_DATA_PRIVACY,
  REGISTRATION_DISPLAY_NAME,
  REGISTRATION_EMAIL,
  REGISTRATION_LOGO,
} from "../../constants/translationKeys";
import translationsStore from "../../stores/TranslationsStore";
import SupervisorStore from "../../stores/SupervisorStore";
import plusImg from "../../assets/images/plus.png";
import { ErrorMessage } from "../../components/ErrorMessage/ErrorMessage";

const BusinessRegistrationPage = () => {
  const [logo, setLogo] = useState<File | null>(null);
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [arePoliciesConfirmed, setArePoliciesConfirmed] = useState(false);
  // useState<String | ArrayBuffer | null>(null);

  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    register("companyLogo", { required: "Please provide a company logo" });
  }, [register]);

  const onLogoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let reader = new FileReader();

    if (e && e.target && e.target.files) {
      const uploadedData = e.target.files[0];
      if (uploadedData) {
        const url = URL.createObjectURL(uploadedData);
        setLogoUrl(url);
        reader.onload = () => {
          const imgBase64 = reader.result;
          setValue("companyLogo", imgBase64);
          //your request
        };

        reader.readAsDataURL(uploadedData);
        setLogo(uploadedData);
      }
    }
  };

  const onSubmit = (data: any) => {
    SupervisorStore.setBusiness(data);
    history.push(PERSON_REGISTRATION);
  };

  const { translations } = translationsStore;
  return (
    <div>
      <Header />
      <div className="page-container">
        <h2>{translations[REGISTRATION_COMPANY_TITLE]}</h2>
        <form
          className="business-registration-form form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="field-wrap">
            <label htmlFor="company-name">
              {translations[REGISTRATION_COMPANY_NAME]}
            </label>
            <input
              id="company-name"
              {...register("companyName", {
                required: "Please provide a company name",
              })}
              placeholder={translations[REGISTRATION_COMPANY_NAME]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="companyName" />
          </div>

          <div className="field-wrap">
            <label htmlFor="company-display-name">
              {translations[REGISTRATION_DISPLAY_NAME]}
            </label>
            <input
              id="company-display-name"
              {...register("companyDisplayName", {
                required: "Please provide a company display name",
              })}
              placeholder={translations[REGISTRATION_DISPLAY_NAME]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="companyDisplayName" />
          </div>

          {/* <div className="field-wrap">
            <label htmlFor="registration_number">
              {translations[REGISTRATION_REG_NUMBER]}
            </label>
            <input
              id="registration_number"
              {...register("registrationNumber", {
                required: "Please provide a registration number",
              })}
              placeholder={translations[REGISTRATION_REG_NUMBER]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="registrationNumber" />
          </div> */}

          <div className="field-wrap">
            <label htmlFor="address">
              {translations[REGISTRATION_ADDRESS]}
            </label>
            <input
              id="address"
              {...register("address", {
                required: "Please provide an address",
              })}
              placeholder={translations[REGISTRATION_ADDRESS]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="address" />
          </div>

          <div className="field-wrap">
            <label htmlFor="company-logo">
              {translations[REGISTRATION_LOGO]}
            </label>
            <label className="input-field logo-label" htmlFor="company-logo">
              <div className="upload-button">
                <p>{!logo ? translations[REGISTRATION_LOGO] : logo.name}</p>
                {!logoUrl ? (
                  <i className="plus-button">
                    <img src={plusImg} alt="..." />
                  </i>
                ) : (
                  <img className="uploaded-logo" src={logoUrl} alt="..." />
                )}
              </div>
            </label>
            <input
              id="company-logo"
              type="file"
              hidden
              onChange={onLogoInputChange}
            />
          </div>
          <ErrorMessage errors={errors} name="companyLogo" />

          <div className="field-wrap">
            <label htmlFor="email">{translations[REGISTRATION_EMAIL]}</label>
            <input
              id="email"
              {...register("email", { required: "Please provide an email" })}
              placeholder={translations[REGISTRATION_EMAIL]}
              className="input-field"
              type="text"
              defaultValue=""
            />
            <ErrorMessage errors={errors} name="email" />
          </div>

          <div className="flex">
            <div className="checkboxRow">
              <input
                name="istructions"
                type="checkbox"
                defaultChecked={arePoliciesConfirmed}
                onChange={(e) => {
                  setArePoliciesConfirmed(e.target.checked);
                }}
              />

              <p
              // onClick={() => {
              //   setArePoliciesConfirmed(!arePoliciesConfirmed);
              // }}
              >
                {translations[REGISTRATION_ACCEPT] || "Accept"}{" "}
                <Link to={DATA_PRIVACY}>
                  {translations[REGISTRATION_DATA_PRIVACY] || "Data Privacy"}
                </Link>
              </p>
            </div>
          </div>
          <button
            className={`button ${
              !arePoliciesConfirmed ? "button--state-disable" : ""
            } filled-button onboarding-continue-button business-registration-form-submit-button`}
          >
            {translations[CONTINUE_BUTTON]}
          </button>
        </form>
      </div>
    </div>
  );
};

export default observer(BusinessRegistrationPage);
